var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 98,
    viewBox: "0 0 107 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.69205 27.6139C9.88611 27.6139 12.4754 24.8316 12.4754 21.3994C12.4754 17.9673 9.88611 15.1849 6.69205 15.1849C3.498 15.1849 0.908691 17.9673 0.908691 21.3994C0.908691 24.8316 3.498 27.6139 6.69205 27.6139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4235 27.6139C47.6176 27.6139 50.2069 24.8316 50.2069 21.3994C50.2069 17.9673 47.6176 15.1849 44.4235 15.1849C41.2294 15.1849 38.6401 17.9673 38.6401 21.3994C38.6401 24.8316 41.2294 27.6139 44.4235 27.6139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1549 27.6139C85.349 27.6139 87.9383 24.8316 87.9383 21.3994C87.9383 17.9673 85.349 15.1849 82.1549 15.1849C78.9609 15.1849 76.3716 17.9673 76.3716 21.3994C76.3716 24.8316 78.9609 27.6139 82.1549 27.6139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69205 62.8142C9.88611 62.8142 12.4754 60.0318 12.4754 56.5997C12.4754 53.1675 9.88611 50.3854 6.69205 50.3854C3.498 50.3854 0.908691 53.1675 0.908691 56.5997C0.908691 60.0318 3.498 62.8142 6.69205 62.8142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4235 62.8142C47.6176 62.8142 50.2069 60.0318 50.2069 56.5997C50.2069 53.1675 47.6176 50.3854 44.4235 50.3854C41.2294 50.3854 38.6401 53.1675 38.6401 56.5997C38.6401 60.0318 41.2294 62.8142 44.4235 62.8142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1549 62.8142C85.349 62.8142 87.9383 60.0318 87.9383 56.5997C87.9383 53.1675 85.349 50.3854 82.1549 50.3854C78.9609 50.3854 76.3716 53.1675 76.3716 56.5997C76.3716 60.0318 78.9609 62.8142 82.1549 62.8142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69205 97.9995C9.88611 97.9995 12.4754 95.2172 12.4754 91.785C12.4754 88.3529 9.88611 85.5706 6.69205 85.5706C3.498 85.5706 0.908691 88.3529 0.908691 91.785C0.908691 95.2172 3.498 97.9995 6.69205 97.9995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4235 97.9995C47.6176 97.9995 50.2069 95.2172 50.2069 91.785C50.2069 88.3529 47.6176 85.5706 44.4235 85.5706C41.2294 85.5706 38.6401 88.3529 38.6401 91.785C38.6401 95.2172 41.2294 97.9995 44.4235 97.9995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1549 97.9995C85.349 97.9995 87.9383 95.2172 87.9383 91.785C87.9383 88.3529 85.349 85.5706 82.1549 85.5706C78.9609 85.5706 76.3716 88.3529 76.3716 91.785C76.3716 95.2172 78.9609 97.9995 82.1549 97.9995Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.790ca5882888afa6069e92f70295e36f.svg";
export { ForwardRef as ReactComponent };